import React from "react";
import FieldLogs from "../FieldLogs/FieldLogs";
import Header from "../../../../UI-Components/Header/header";
import InsideTransactionHeader from "../InsideTransactionHeader";

const RaceTripLogs = () => {
  return (
    <>
      <Header pageTitle="Logs Management" />
      <div className="content heightfull cont">
        <div className="content-left-panel" style={{ width: "25rem" }}>
          <InsideTransactionHeader selectionType="raceTrip" />
        </div>
        <FieldLogs logType="RACETRIP" />
      </div>
    </>
  );
};

export default RaceTripLogs;
